module.exports = __webpack_public_path__ + "static/media/9.19cbd40e.jpg";